import React, { FC, memo } from "react";
import { IM12TextBlock } from "@montana/models/generated/cms.interface";
import { RichText } from "@montana/shared/rich-text";

export const M12TextModuleBlock: FC<IM12TextBlock> = memo(({ header, leftColumn, rightColumn, onlyUseLeftColumn }: IM12TextBlock) => {

    return (
        <section className={`text-module-block${onlyUseLeftColumn ? ' text-module-block--article' : ''}`}>
            {header && <RichText className="text-module-block__header" text={header} />}
            <div className="text-module-block__columns">
                {!!leftColumn && (
                    <div className="text-module-block__left-column">
                        <RichText text={leftColumn} />
                    </div>
                )}
                {(!!rightColumn && !onlyUseLeftColumn) && (
                    <div className="text-module-block__right-column">
                        <RichText text={rightColumn} />
                    </div>
                )}
            </div>
        </section>
    )
})